export default __webpack_public_path__ + "static/media/00-principal_thumb.9f1f11e5.png";